export default "__VITE_ASSET__22cd7954__"